import React from "react";
import { Button, Modal, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const HeaderText = styled("h4")(() => ({
    marginTop: "45px",
    textAlign: "left",
    fontSize: "18px",
    marginLeft: "24px",
}));

const ModalContainer = styled("div")(({ theme }) => ({
    margin: "0 auto",
    marginTop: "10%",
    position: "relative",
    alignItems: "center",
    borderRadius: "3px",
    "&:focus": {
        outline: "none",
    },
    width: "400px",
    height: "200px",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
}));

const TrackResearchModal = (props) => {
    const { modalOpen, closeModal, trackedValue, confirm } = props;

    const affirmativeClick = () => {
        closeModal();
        confirm();
    };

    return (
        <Modal
            open={modalOpen}
            onClose={() => closeModal()}
            style={{
                height: "60vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "10vh",
            }}
        >
            <ModalContainer>
                <HeaderText>{trackedValue === true ? "Stop Tracking Property?" : "Track Property?"}</HeaderText>
                <Typography variant="body1" style={{ marginRight: "24px", marginLeft: "24px" }}>
                    {trackedValue === true
                        ? "Are you sure you want to stop tracking this property?"
                        : "Are you sure you want to start tracking this property?"}
                </Typography>
                <div style={{ position: "absolute", bottom: 24, right: 24 }}>
                    <Button
                        style={{ display: "inline-block", marginLeft: "10px" }}
                        variant="outlined"
                        onClick={() => closeModal()}
                    >
                        No
                    </Button>
                    <Button
                        style={{ display: "inline-block", marginLeft: "10px" }}
                        variant="contained"
                        color="primary"
                        onClick={() => affirmativeClick()}
                    >
                        Yes
                    </Button>
                </div>
            </ModalContainer>
        </Modal>
    );
};

const styles = (theme) => ({
    header: {
        marginTop: "45px",
        textAlign: "left",
        fontSize: "18px",
        marginLeft: "24px",
    },
    container: {
        margin: "0 auto",
        marginTop: "10%",
        position: "relative",
        alignItems: "center",
        borderRadius: "3px",
        "&:focus": {
            outline: "none",
        },
        width: "400px",
        height: "200px",
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
    },
});

export default TrackResearchModal;
